module.exports = [{
      plugin: require('/home/sk_b0y/cos1/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
